export default (props, e) => {
    e.preventDefault();
    if (document.referrer.split('/')[2] === window.location.host) {
        let useFallbackHref = true;
        window.onbeforeunload = function(){
            useFallbackHref = false;
        }
        window.history.back();

        setTimeout(function(){
            if (useFallbackHref){ window.location.href = e.target.href; }
        }, 100);
    } else {
        if (e.target.href) {
            window.location.href = e.target.href;
        }
    }
};



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/webActions/goBack.js